import React from 'react'

import AlertDismissable from '../../components/shared/AlertDismissable';

const MimeTypeError = ({ hasError, accept }) => (
    hasError ? (
        <AlertDismissable bsStyle="danger">
            <strong>Error!</strong> File type must be one of <strong>{accept.join(', ')}</strong>
        </AlertDismissable>
    ) : null
)

const InvalidDataWarning = ({ invalidRows }) => (
    (invalidRows > 0) ? (
        <AlertDismissable bsStyle="warning">
            <strong>Warning!</strong> Spreadsheet contains invalid data. Please correct the issues in your file using the information below and resubmit.
        </AlertDismissable>
    ) : null
)

const UploadSuccess = ({ isSuccess, lastSuccessCount }) => (
    (isSuccess) ? (
        <AlertDismissable bsStyle="success">
            <strong>Success!</strong> A total of <strong>{lastSuccessCount} row{(lastSuccessCount > 1) && 's'}</strong> {(lastSuccessCount > 1) ? 'were' : 'was'} uploaded to the whitelist queue.
            You will receive an email when the data has been processed.
        </AlertDismissable>
    ) : null
)

const UploadError = ({ isError }) => (
    (isError) ? (
        <AlertDismissable bsStyle="danger">
            <strong>Error!</strong> There was an error uploading your spreadsheet data. Please try again in a few minutes.
        </AlertDismissable>
    ) : null
)

export default {
    MimeTypeError,
    InvalidDataWarning,
    UploadSuccess,
    UploadError,
}
